import classNames from 'classnames';
import { Link, Outlet, useLocation } from 'react-router-dom';
import { TabView, TabPanel } from 'primereact/tabview';

import { routes } from 'constants/index';

import './list-five-layout.scss';

export default function ListFiveLayout() {
  const { pathname } = useLocation();

  return (
    <div className="list-five-layout">
      {/* Without onTabChange, TabView reads activeIndex once and then keeps
          its own state. The sidebar lands on /list-five before redirecting
          to need-approval, so it stuck on Other invoices. With it, the tab
          follows the URL; the Link in each header does the navigating. */}
      <TabView
        activeIndex={pathname.includes(routes.listFive.otherInvoices) ? 1 : 0}
        onTabChange={() => {}}
      >
        <TabPanel
          header={
            <Link
              to={routes.listFive.needApproval}
              className={classNames({
                'list-five-layout__invoice-tabs-tab': true,
                'list-five-layout__invoice-tabs-tab--active': pathname.includes(
                  routes.listFive.needApproval
                ),
              })}
              role="presentation"
            >
              Need for approval
            </Link>
          }
        >
          <Outlet />
        </TabPanel>

        <TabPanel
          header={
            <Link
              to={routes.listFive.otherInvoices}
              className={classNames({
                'list-five-layout__invoice-tabs-tab': true,
                'list-five-layout__invoice-tabs-tab--active': pathname.includes(
                  routes.listFive.otherInvoices
                ),
              })}
              role="presentation"
            >
              Other invoices
            </Link>
          }
        >
          <Outlet />
        </TabPanel>
      </TabView>
    </div>
  );
}
